//@flow

import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import SmallLoadingWrapper from '../../../Loading/SmallLoadingWrapper';

import {
  patchOverviewEdits,
  updateOverviewEdits,
} from '../../../../redux/actions/overviewEditorActions';

import { closeOverviewModal } from '../../../../redux/actions/trekOverviewActions';

import { getToastMsg } from '../../../ErrorMessage';

import { Formik, Field } from 'formik';
import { PriceEditorSchema } from '../../constants';

type Props = {
  price: {
    currenct: string,
    amount: number,
  },
  trekId: string,
  closeOverviewModal: () => void,
  closeEditorl: () => void,
  patchOverviewEdits: () => void,
  updateOverviewEdits: () => void,
};

class PriceEditor extends Component<Props> {
  render() {
    const {
      closeOverviewModal,
      price: { amount },
    } = this.props;
    return (
      <Fragment>
        <div id="basic-info-editor">
          <Formik
            initialValues={{
              price: amount,
            }}
            validationSchema={PriceEditorSchema}
            onSubmit={(values, { setSubmitting }) => {
              this.handleSave(values, setSubmitting);
            }}
            render={({ handleSubmit, errors, isSubmitting }) => (
              <SmallLoadingWrapper showLoading={isSubmitting}>
                <form onSubmit={handleSubmit}>
                  <div className="d-mobile">
                    <div className="d-flex justify-content-between mb-2 border-bottom">
                      <h2>EDIT PRICE (USD)</h2>
                      <a onClick={closeOverviewModal} style={{ fontSize: '14px' }}>
                        <i className="icon icon-hg-cross" aria-hidden="true" />
                      </a>
                    </div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="price">Please Enter you price to update</label>
                    <Field
                      name="price"
                      type="number"
                      component="input"
                      placeholder="1200"
                      className="form-control"
                    />
                    {errors.price && (
                      <p className="error">{this.reformatError(errors.price)}</p>
                    )}
                  </div>
                  <div className="text-center">
                    <button type="submit" className="btn btn-yellow">
                      <i className="icon icon-hg-save" aria-hidden="true" /> Save
                    </button>
                  </div>
                </form>
              </SmallLoadingWrapper>
            )}
          />
        </div>
      </Fragment>
    );
  }

  reformatError = error =>
    error.includes('must be a number type') ? 'Should be a number' : error;

  handleSave = (values, setSubmitting) => {
    const {
      patchOverviewEdits,
      updateOverviewEdits,
      closeOverviewModal,
      trekId,
      price: trekPrice,
    } = this.props;

    const { price } = values;

    const patchObj = { price: { amount: +price, currency: trekPrice.currency } };

    patchOverviewEdits(trekId, patchObj)
      .then(() => {
        updateOverviewEdits(patchObj);
        closeOverviewModal();
        getToastMsg({ status: 'success', type: 'changeTrekPrice' });
        setSubmitting(false);
      })
      .catch(() => {
        getToastMsg({ status: 'error', type: 'changeTrekPrice' });
        setSubmitting(false);
      });
  };
}

const mapStateToProps = ({ selectedTrek }) => ({
  trekId: selectedTrek.trek.id,
  price: selectedTrek.trek.price,
});

export default connect(
  mapStateToProps,
  {
    patchOverviewEdits,
    updateOverviewEdits,
    closeOverviewModal,
  }
)(PriceEditor);



// WEBPACK FOOTER //
// ./src/components/TrekDetail/Editors/TrekPriceEditor/PriceEditor.jsx